export default {
  name: 'form-login',

  ui: {
    login: '[js-login]',
    recover: '[js-recover]',
    btnHideRecover: '[js-hide-recover]',
    btnShowRecover: '[js-show-recover]',
  },

  events: [
    {
      target: 'btnHideRecover',
      on: 'click',
      handle: 'hideRecover',
    },
    {
      target: 'btnShowRecover',
      on: 'click',
      handle: 'showRecover',
    },
  ],

  componentDidMount () {
    if (window.location.hash === '#recover') {
      this.showRecover()
    }
  },

  hideRecover (e) {
    e.preventDefault()
    this.ui.login.classList.remove('hidden')
    this.ui.recover.classList.add('hidden')
  },

  showRecover (e) {
    if (e !== undefined) {
      e.preventDefault()
    }

    this.ui.login.classList.add('hidden')
    this.ui.recover.classList.remove('hidden')
  },
}
